import {Modal} from "antd";
import {EmployeeDetailModalProps} from "../../../../types/employee";
import React, {FC} from "react";
import {getImageLink} from "../../../../helpers/mainHelpers";
import * as BUCKETS from "../../../../enums/buckets";
import "./style.less"
import TextReader from "../../../../components/text-reader/TextReader";
import {IdcardOutlined, MedicineBoxOutlined} from "@ant-design/icons";

const EmployeeDetailModal: FC<EmployeeDetailModalProps> = ({employeeController}) => {
  const {toggleDetailModal, isDetailModalOpen, selectedEmployee} = employeeController

  return <Modal
    centered
    className="employee-detail-modal"
    width={980}
    footer={null}
    open={isDetailModalOpen}
    onCancel={toggleDetailModal}
    title={<span className="employee-detail-modal__modal-title"><IdcardOutlined/> Профіль працівника</span>}
  >
    {selectedEmployee && <article className="employee-profile">
      <div className="employee-profile__visual">
        <div className="employee-profile__portrait">
          {selectedEmployee.image
            ? <img
              className="employee-profile__image"
              src={getImageLink({imageId: selectedEmployee.image, bucketId: BUCKETS.MAIN})}
              alt={`Фото: ${selectedEmployee.fullName}`}
            />
            : <div className="employee-profile__placeholder" aria-hidden="true">
              {selectedEmployee.fullName?.trim().charAt(0) || "А"}
            </div>}
        </div>
        <div className="employee-profile__visual-accent" aria-hidden="true"/>
      </div>

      <div className="employee-profile__content">
        <div className="employee-profile__eyebrow"><MedicineBoxOutlined/> Адміністрація лікарні</div>
        <h2 className="employee-profile__name">{selectedEmployee.fullName}</h2>
        <p className="employee-profile__position">{selectedEmployee.position}</p>

        {selectedEmployee.about && <section className="employee-profile__about" aria-labelledby="employee-about-title">
          <h3 className="employee-profile__section-title" id="employee-about-title">Основна інформація</h3>
          <div className="employee-profile__divider"/>
          <TextReader value={selectedEmployee.about}/>
        </section>}
      </div>
    </article>}
  </Modal>
}

export default EmployeeDetailModal
